import React, { FC } from 'react';
import {
  GetTransactionsViaTransactionNoResponse,
  TransactionPrintPageData
} from 'src/types';
import { Page as PDFPage, View, StyleSheet } from '@react-pdf/renderer';
import { RenderCustomerInfo } from './RenderCustomerInfo';
// import { RenderEmployeeInfo } from './RenderEmployeeInfo';
import { RenderItemsTable } from './RenderItems';
import { RenderPageNoAndTotal } from './RenderPageNoAndTotal';
import { RenderWarrantySlipTitle } from './RenderWarrantySlipTitle';
import { RenderFooter } from './RenderFooter';
import { RenderCompanyInfo } from './RenderCompanyInfo';

interface Props {
  pagesData?: TransactionPrintPageData[];
  transactionStateData?: GetTransactionsViaTransactionNoResponse | null;
  dateSold?: string;
  isSIPricing?: boolean;
  totalAmount?: number;
  releasedBy?: string;
  storeBranch?: string;
  overrideOnURL?: string;
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: 'white'
  },
  container: {
    margin: 15,
    flex: 1
  }
});

export const RenderPages: FC<Props> = ({
  pagesData,
  transactionStateData,
  dateSold,
  isSIPricing,
  totalAmount,
  // releasedBy,
  storeBranch = '',
  overrideOnURL = ''
}) => {
  return (
    <>
      {pagesData?.map((pageData, i) => (
        <PDFPage key={i} size={[421, 612]} style={styles.page}>
          <View style={styles.container}>
            {overrideOnURL ? (
              <RenderCompanyInfo
                storeLocation={transactionStateData?.store_address}
              />
            ) : null}
            <RenderWarrantySlipTitle
              overrideOnURL={overrideOnURL}
              storeBranch={storeBranch}
              orderNo={transactionStateData?.order_no}
              transactionNo={transactionStateData?.transaction_no}
            />
            <RenderCustomerInfo
              overrideOnURL={overrideOnURL}
              dateSold={dateSold}
              customerInfo={transactionStateData?.customer}
              paymentMode={transactionStateData?.payment_mode}
            />
            <RenderItemsTable
              items={pageData?.page?.items}
              kachiPoints={transactionStateData?.kachi_points}
              voucherDiscount={transactionStateData?.voucher_discount}
              voucher_code={transactionStateData?.voucher_code}
              isLastPage={i === pagesData.length - 1}
            />
            <RenderPageNoAndTotal
              pageNo={pageData?.pageNo}
              pageTotal={pagesData?.length}
              isSIPricing={isSIPricing}
              totalAmount={totalAmount}
            />
            {/* <RenderEmployeeInfo
              overrideOnURL={overrideOnURL}
              releasedBy={releasedBy}
            /> */}
            <RenderFooter
              overrideOnURL={overrideOnURL}
              customerInfo={transactionStateData?.customer}
            />
          </View>
        </PDFPage>
      ))}
    </>
  );
};
